import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

export default ComposedComponent => {
  class Container extends Component {
    constructor(...args) {
      super(...args);
      this.state = {
        content: this.props.config ? this.props.config : {},
      };

      this.updateContent = this.updateContent.bind(this);
    }

    updateContent(index, content) {
      this.setState(prevState => ({
        content: update(prevState.content, { [index]: { $set: content } }),
      }));

      this.props.updateFields(
        this.props.index,
        update(this.state.content, { [index]: { $set: content } })
      );
    }

    render() {
      return createElement(
        ComposedComponent,
        {
          ...this.props,
          updateContent: this.updateContent,
        },
        null
      );
    }
  }

  Container.propTypes = {
    config: PropTypes.object,
    index: PropTypes.number,
    updateFields: PropTypes.func,
  };

  return Container;
};
